import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.currentUserId"],
  (currentUserId: any): any => currentUserId
);
